import { BadgeCheck, Disc3, MapPin, Users } from "lucide-react";
import { useMemo, useState } from "react";

function UserCard({ title, image, model, artist, duration, onOpenDetails }) {
  const [imageFailed, setImageFailed] = useState(false);

  const userInfo = useMemo(() => {
    const username = model?.username || title || "Unknown User";
    const fullName = model?.full_name || "";
    const verified = Boolean(model?.verified);
    const locationParts = [model?.city, model?.country_code].filter(Boolean);
    const location = locationParts.join(", ");

    return {
      username,
      fullName,
      verified,
      location,
      tracksLabel: artist || `${Number(model?.track_count) || 0} tracks`,
      followersLabel: duration || `${Number(model?.followers_count) || 0} followers`,
    };
  }, [artist, duration, model, title]);

  return (
    <article
      className="user-card glass-panel"
      role="button"
      tabIndex={0}
      onClick={() => onOpenDetails?.(model)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onOpenDetails?.(model);
        }
      }}
      aria-label={`Open profile details for ${userInfo.username}`}
    >
      <div className="user-card-head">
        {image && !imageFailed ? (
          <img
            className="user-card-avatar"
            src={image}
            alt={userInfo.username}
            onError={() => setImageFailed(true)}
          />
        ) : (
          <div className="user-card-avatar-fallback" aria-label="No avatar">
            <Disc3 size={18} />
          </div>
        )}

        <div className="user-card-title-wrap">
          <div className="user-card-title-line">
            <p className="user-card-title">{userInfo.username}</p>
            {userInfo.verified ? (
              <span className="user-verified-badge" title="Verified artist" aria-label="Verified artist">
                <BadgeCheck size={13} />
              </span>
            ) : null}
          </div>
          <p className="user-card-role">{userInfo.verified ? "Verified artist" : "Creator"}</p>
        </div>
      </div>

      {userInfo.fullName ? <p className="user-card-fullname">{userInfo.fullName}</p> : null}
      {userInfo.location ? (
        <p className="user-card-location">
          <MapPin size={13} />
          {userInfo.location}
        </p>
      ) : null}

      <div className="user-card-meta">
        <span>{userInfo.tracksLabel}</span>
        <span>
          <Users size={13} />
          {userInfo.followersLabel}
        </span>
      </div>
    </article>
  );
}

export default UserCard;
